async function loadAllProducts() {
  const templateSuffix = "product-json";
  const collectionHandle = "all";
  const urlPrefix = window.routes.root;

  if (urlPrefix !== "/") urlPrefix += "/";

  const response = await fetch(
    `${urlPrefix}collections/${collectionHandle}?view=${templateSuffix}`,
    {
      type: "GET",
    }
  );

  const json = await response.json();
  window.ALL_PRODUCTS = json.products;
}

loadAllProducts();

// const activeCartBtn = document.querySelector(".js-active-cart");
// const pointsAddToCartButton = document.querySelector(".button.points-add-to-cart-button");
// const newCartDrawer = document.querySelector("custom-drawer");
// const newCartDrawerBody = newCartDrawer.querySelector(".drawer__body");

//function initCart() {
  // setCartCount();

  // if (activeCartBtn) {
  //   activeCartBtn.addEventListener("click", () => {
  //     showCart();
  //   });
  // }

  // if (pointsAddToCartButton) {
  //   pointsAddToCartButton.addEventListener("click", () => {
  //     let variantId = pointsAddToCartButton.dataset.variantId;

  //     const variantsJsonEl = document.querySelector('variant-radios > script[type="application/json"]')
  //     if (variantsJsonEl) { 
  //       const variants = JSON.parse(variantsJsonEl.innerText);

  //       if (variants.length > 1) {
  //         // For each of the fieldsets, find the checked input
  //         const fieldsets = document.querySelectorAll("variant-radios > fieldset");
  //         const checkedInputs = [];
  //         fieldsets.forEach((fieldset) => {
  //           const checkedInput = fieldset.querySelector("input:checked");
  //           if (checkedInput) {
  //             checkedInputs.push(checkedInput);
  //           }
  //         });

  //         // If there are checked inputs, find the variant ID
  //         if (checkedInputs.length > 0) {
  //           const checkedInputValues = checkedInputs.map((input) => input.value);
  //           const checkedInputValuesString = checkedInputValues.join(" / ");
  //           const variant = variants.find((v) => v.title === checkedInputValuesString);
  //           if (variant) {
  //             variantId = variant.id;
  //           }
  //         }
  //       }
  //     }

  //     const variant = window.ALL_PRODUCTS.find(
  //       (p) => p.id == variantId
  //     );

  //     if (!variant) return;

  //     addToSessionCart(variant);
  //     setCartCount();
  //     showCart();
  //   });
  // }

 // const checkoutBtn = newCartDrawer.querySelector(".custom-cart-checkout-btn");
 // const checkoutMessage = newCartDrawer.querySelector(".custom-cart-checkout-message");

 // if (checkoutBtn) {
  //  checkoutBtn.addEventListener("click", () => {
  //    checkoutBtn.innerHTML = "Submitting order...";
  //    checkoutBtn.classList.add("disabled");
  //    checkoutMessage.innerHTML = "";
      
      // Send a reques to the server to create an order "https://turtle-lenus-backend-5wtyka2oka-ew.a.run.app/api/orders"
      // If the order is created successfully, show a success message
      // If the order is not created successfully, show an error message
      // If the user does not have enough points, show an error message
  //    const cart = JSON.parse(sessionStorage.getItem("cart")) || [];
  //    const totalPoints = cart.reduce((acc, curr) => {
  //      return acc + curr.price_points;
  //    }, 0);

   //   const pointsBalance = document.querySelector(".header__customer-points-balance");

   //   if (pointsBalance) {
   //     const pointsBalanceAmount = parseInt(pointsBalance.dataset.points);
   //     if (pointsBalanceAmount < totalPoints) {
   //       console.log("You do not have enough points");
   //       return;
   //     }
   //   }

   //   const customerId = pointsBalance.dataset.customerId;

   //   if(!customerId) {
   //     console.log("Could not find customer ID");
   //     return;
   //   }

    //  const order = {
    //    customer_id: customerId,
    //    line_items: cart.map((v) => {
    //      const quantity = 1;
//
    //      return {
    //        price: (v.price / 100),
    //        price_points: v.price_points,
    //        total_price_points: v.price_points * quantity,
    //        variant_id: v.id,
    //        quantity: quantity,
    //      };
    //    }),
    //  };

    //  fetch("https://turtle-formalize-backend-222804631241.europe-west1.run.app/api/orders", {
    //    method: "POST",
    //    headers: {
    //      "Content-Type": "application/json",
    //    },
    //    body: JSON.stringify(order),
    //  })
    //    .then((res) => res.json())
    //    .then((res) => {
    //      if (res.message) {
    //        checkoutBtn.innerHTML = "Complete order";
    //        checkoutBtn.classList.remove("disabled");

      //      if (res.message.includes("Customer has already made an order")) {
      //        checkoutMessage.innerHTML = "You have already made an order.";
      //      } else if (res.message.includes("enough points")) {
      //        checkoutMessage.innerHTML = "You do not have enough points.";
      //      } else {
      //        checkoutMessage.innerHTML = "Order could not be created...";
      //      }
      //    } else {
       //     sessionStorage.removeItem("cart");
       //     setCartCount();
       //     renderCart();

       //     newCartDrawerBody.innerHTML = `
       //       <div class="custom-cart-item__empty">
       //         <div class="drawer__body-empty__title">Your order has been received and is now in the capable hands of our dedicated production team.</div>
       //         <div class="drawer__body-empty__subtitle">You will receive an email confirmation shortly.</div>
       //         <a href="/account" class="drawer__body-empty__button">Go to account</a>
       //       </div>
       //     `;

       //     newCartDrawer.classList.add("hide-footer");
       //   }
       // })
       // .catch((err) => {
       //   console.log("Could not create order");
       //   checkoutBtn.innerHTML = "Complete order";
       //   checkoutBtn.classList.remove("disabled");
       // });
 //   });
//  }
//}

// initCart();
/*
function addToSessionCart(variant) {
  // Generate a random ID
  const itemId = Math.random().toString(36).substr(2, 9);
  variant.cart_item_id = itemId;
  const cart = JSON.parse(sessionStorage.getItem("cart")) || [];
  cart.push(variant);
  sessionStorage.setItem("cart", JSON.stringify(cart));
}

function setCartCount() {
  const cart = JSON.parse(sessionStorage.getItem("cart")) || [];
  const cartCount = document.querySelector(".js-cart-count");
  cartCount.textContent = cart.length;
}

function renderCart() {
  const cart = JSON.parse(sessionStorage.getItem("cart")) || [];
  const cartItems = cart.map((variant) => {
    let image = variant.variant_image;

    if (image.includes("no-image")) {
      image = variant.image;
    }

    return `
      <div class="custom-cart-item" data-cart-item-id="${variant.cart_item_id}" data-variant-id="${variant.id}">
        <div class="custom-cart-item__image">
          <img src="${image}" alt="${variant.title}" />
        </div>
        <div class="custom-cart-item__details">
          <div class="custom-cart-item__title">${variant.title}</div>
          <div class="custom-cart-item__subtitle">${variant.variant_title}</div>
          <div class="custom-cart-item__points">${variant.price_points} points</div>
        </div>
        <div class="custom-cart-item__action">
          <div class="custom-cart-item__remove">
            Remove
          </div>
        </div>
      </div>
    `;
  });

  newCartDrawerBody.innerHTML = cartItems.join("");

  const removeButtons = newCartDrawerBody.querySelectorAll(
    ".custom-cart-item__remove"
  );

  removeButtons.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      const cartItemId = e.target.closest(".custom-cart-item").dataset.cartItemId;
      const cart = JSON.parse(sessionStorage.getItem("cart")) || [];
      const newCart = cart.filter((v) => v.cart_item_id != cartItemId);
      sessionStorage.setItem("cart", JSON.stringify(newCart));
      setCartCount();
      renderCart();
    });
  });

  // If 0 cartItems, hide the footer
  if (cartItems.length === 0) {
    newCartDrawer.classList.add("hide-footer");
  } else {
    newCartDrawer.classList.remove("hide-footer");
  }

  // If 0 cartItems, show empty message inside the body
  if (cartItems.length === 0) {
    newCartDrawerBody.innerHTML = `
      <div class="custom-cart-item__empty">
        <div class="custom-cart-item__empty__title">Your cart is empty</div>
      </div>
    `;
  }

  // Add the total sum of the points for the cart to the footer, inside the selector "custom-cart-checkout-total-points-label"
  const totalPoints = cart.reduce((acc, curr) => {
    return acc + curr.price_points;
  }, 0);

  const totalPointsLabel = newCartDrawer.querySelector(
    ".custom-cart-checkout-total-points-label"
  );

  if (totalPointsLabel) {
    totalPointsLabel.textContent = "Total: " + totalPoints + " points";
  }

  // Get the current amount of available points from the user
  const pointsBalance = document.querySelector(".header__customer-points-balance");
  
  if(pointsBalance) {
    const pointsBalanceAmount = parseInt(pointsBalance.dataset.points);
    const pointsStatusEl = newCartDrawer.querySelector(".custom-cart-checkout-total-points-status");
    pointsStatusEl.classList.remove("error");
    
    if (pointsStatusEl) {
      // Show a message with the amount of points left
      const pointsLeft = pointsBalanceAmount - totalPoints;
      pointsStatusEl.textContent = `You have ${pointsLeft} points left`;

      // If the user does not have enough points, show a specific message
      if (pointsBalanceAmount < totalPoints) {
        // pointsStatusEl.textContent = `You have ${pointsBalanceAmount} points.`;
        pointsStatusEl.textContent = `You do not have enough points.`;
        pointsStatusEl.classList.add("error");
      }

      // If the user does not have enough points, disable the checkout button
      const checkoutButton = newCartDrawer.querySelector(".custom-cart-checkout-btn");
      if (pointsBalanceAmount < totalPoints) {
        checkoutButton.classList.add("disabled");
      } else {
        checkoutButton.classList.remove("disabled");
      }
    }
  }
}

function showCart() {
  renderCart();
  newCartDrawer.classList.add("active");
}

function hideCart() {
  newCartDrawer.classList.remove("active");
}
*/